<template>
  <v-dialog v-model="show" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on">
        <v-icon left>add</v-icon>Nouveau produit
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-row align="center" justify="space-between" no-gutters>
          <span>Ajout d'un produit</span>
          <v-btn icon @click="show = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row dense>
            <v-col>
              <RecipeProductTagsEditor
                v-model="tags"
                solo-inverted
              ></RecipeProductTagsEditor>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-text-field
                autofocus
                v-model="name"
                :rules="[v => !!v || 'Un nom est requis']"
                label="Nom"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <j-decimal-input
                v-model="price"
                label="Prix"
                required
              ></j-decimal-input>
            </v-col>
            <v-col>
              <v-select
                v-model="unit"
                :rules="[v => !!v || 'Une unité est requis']"
                :items="getAllowedUnits"
                label="Unité de mesure"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <j-decimal-input
                v-model="price_inventory"
                label="Prix pour l'inventaire"
              ></j-decimal-input>
            </v-col>
            <v-col>
              <v-select
                v-model="unit_inventory"
                :items="getAllowedUnits"
                label="Unité de mesure pour l'inventaire"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="end" no-gutters>
          <v-btn :disabled="!valid" color="primary" @click="addProduct"
            >Ajouter</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import RecipeProductTagsEditor from "./RecipeProductTagsEditor";
export default {
  name: "RecipeProductAdder",
  components: {
    RecipeProductTagsEditor
  },
  computed: {
    ...mapGetters(["getAllowedUnits", "getOrganisationId"])
  },
  data() {
    return {
      valid: false,
      name: null,
      unit: null,
      price: 0,
      unit_inventory: null,
      price_inventory: null,
      tags: [],
      show: false
    };
  },
  methods: {
    async addProduct() {
      if (this.valid) {
        this.$store.dispatch("startLoadingOverlay");
        const data = {
          organisation: this.getOrganisationId,
          nom: this.name,
          unite_mesure: this.unit,
          prix: this.price,
          unite_mesure_inventory: this.unit_inventory,
          prix_inventory: this.price_inventory,
          est_intermediaire: false,
          tags: this.tags.length > 0 ? this.tags : undefined
        };
        try {
          await this.$store.dispatch("addRecipeProduct", data);
          this.$refs.form.reset();
          this.tags = [];
          this.show = false;
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
